import { Product, ProductPagination } from '@utilities/types';
import React, { createContext, useState } from 'react';

interface ProductContextType {
    products: Product[];
    setProducts: React.Dispatch<React.SetStateAction<Product[]>>;
    productsPagination: ProductPagination | null;
    setProductsPagination: React.Dispatch<React.SetStateAction<ProductPagination | null>>;
}

export const ProductContext = createContext<ProductContextType>({
    products: [],
    setProducts: () => { },
    productsPagination: null,
    setProductsPagination: () => { },
});

export const ProductContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [products, setProducts] = useState<Product[]>([]);
    const [productsPagination, setProductsPagination] = useState<ProductPagination | null>(null);

    return (
        <ProductContext.Provider
            value={{ 
                products, setProducts,
                productsPagination, setProductsPagination,
            }}>
            {children}
        </ProductContext.Provider>
    );
};
